import { checkDocumentExist } from "@/api/documentexist";
import { _updateData } from "@/api/esdata";
export const ruleName = (parentVue) => {
    return {
        validate: [
            {
                required: true,
                message: "Missing Rule Name",
                trigger: "blur",
            },
            {
                validator: (rule, value, callback, source, options) => {
                    var vm = parentVue.$refs.rcmTable;
                    if (!/^[a-z0-9\_]*$/.test(value))
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9 _`));
                    if (value.length > 35)
                        return callback(new Error(`${vm.$i18n.t("rcmtable.validateExceedLengthPrefix")}: 35`));
                    if (value == "sys_default")
                        return callback(new Error("System Reserved Name"));
                    checkDocumentExist({
                        topic: "owaspRuleId",
                        fieldVal: value,
                        groupName: vm.formData.groupName,
                    }).then((result) => {
                        if (!result.data.success) {
                            return callback(new Error("Duplicate ruleName"));
                        }
                        callback();
                    });
                },
                trigger: "blur",
            },
        ],
    };
};

export const description = (parentVue) => {
    return {
        sectionKey: "essential",
        render: (h, params) => {
            return h(
                "div",
                params.row.description.split("\n").map(function (o) {
                    return h(
                        "P",
                        {
                            props: {},
                        },
                        o
                    );
                })
            );
        },
    };
};

export const wafUri = (parentVue) => {
    return {
        vShowFieldVal: (item) => {
            let vm = parentVue.$refs.rcmTable;
            let filterDetect = vm.$store.state.platformPlan.multiTenancyConfigs.wafSetting.detect.find(
                (detect) => detect.isShow && detect.id == "url"
            );
            return filterDetect && item.wafAction == "16" ? 1 : 0;
        },
    };
}



// WEBPACK FOOTER //
// ./src/view/OWASP/fields.js